/* eslint-disable react/prop-types */
import AnnouncementModalComponent from "./announcement-modal";
import * as detailSlice from "../detail.slice";
import { useDispatch } from "react-redux";
import * as announcementHelper from "@/common/announcement-helper";

function AnnouncementModal({ announcement }) {
  const dispatch = useDispatch();
  const {
    title,
    description,
    regions,
    cities,
    beneficiary,
    outgoings,
    types,
    granted,
    promoting,
    maxContribution,
  } = announcement;

  const status = announcementHelper.getStatus({ announcement });

  const dateLabel = announcementHelper.getDataLabel(status);

  const date = announcementHelper.getDate(status, announcement);

  const handleCloseClick = () => {
    dispatch(detailSlice.setModalAnnouncement({}));
  };

  return (
    <AnnouncementModalComponent
      title={title}
      description={description}
      onCloseClick={handleCloseClick}
      status={status}
      promoting={promoting}
      maxContribution={maxContribution}
      cities={announcementHelper.getGeographicalArea(cities, regions)}
      beneficiary={announcementHelper.listToString(beneficiary)}
      outgoings={announcementHelper.listToString(outgoings)}
      types={announcementHelper.listToString(types)}
      granted={granted}
      dateLabel={dateLabel}
      date={date}
    />
  );
}

export default AnnouncementModal;
